var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 13.3333V10.1666C9.1665 9.70635 9.5396 9.33325 9.99984 9.33325C10.4601 9.33325 10.8332 9.70635 10.8332 10.1666V13.3333C10.8332 13.7935 10.4601 14.1666 9.99984 14.1666C9.5396 14.1666 9.1665 13.7935 9.1665 13.3333Z",
    fill: "#0062FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 7.66658C10.8332 7.20635 10.4601 6.83325 9.99984 6.83325C9.5396 6.83325 9.1665 7.20635 9.1665 7.66658C9.1665 8.12682 9.5396 8.49992 9.99984 8.49992C10.4601 8.49992 10.8332 8.12682 10.8332 7.66658Z",
    fill: "#0062FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3332 9.99992C18.3332 5.39754 14.6022 1.66658 9.99984 1.66658C5.39746 1.66658 1.6665 5.39754 1.6665 9.99992C1.6665 14.6023 5.39746 18.3333 9.99984 18.3333C14.6022 18.3333 18.3332 14.6023 18.3332 9.99992ZM3.33317 9.99992C3.33317 6.31802 6.31794 3.33325 9.99984 3.33325C13.6817 3.33325 16.6665 6.31802 16.6665 9.99992C16.6665 13.6818 13.6817 16.6666 9.99984 16.6666C6.31794 16.6666 3.33317 13.6818 3.33317 9.99992Z",
    fill: "#0062FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoblue);
export default __webpack_public_path__ + "static/media/infoblue.55ef7b76685915e17616942037610673.svg";
export { ForwardRef as ReactComponent };